import { render, staticRenderFns } from "./value-editor.vue?vue&type=template&id=42ba1a82&"
import script from "./value-editor.vue?vue&type=script&lang=js&"
export * from "./value-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports